export default {
  'usual-menus.first-nav': 'Shortcut',
  'usual-menus.select-menu': 'Select Menu',
  'usual-menus.select-menu.placeholder': 'Enter keywords to search',
  'usual-menus.no-data': 'No Data Available',
}
